import axios from 'axios';
import { config } from './config.js';

export var api = {
    getPageLoading : function(){
        //return vue_instance.page_loading;
    },
    base : function(){
        var token = localStorage.getItem('token');
        return axios.create({
            baseURL: config.API_BASE,
            withCredentials: false,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization' : token,
                'Autrollization' : token,
                'Hash-Teatro': localStorage.getItem('hash_teatro')
            }
        });
    },

    call : function(api_route, data = { filters: {} }, options = {}){
        var str_params = '';
        var url = api_route.url;

        if(!data.filters) data.filters = {};

        if(data.filters)
            str_params = this.format_url_params(data.filters);

        url = url + str_params;

        url = this.format_url_merge_tags(url, data);

        switch(api_route.method){
            case 'GET' :
                if(options.responseType === 'blob') {
                    return this.getFile(url);
                }
                return this.get(url, data);

            case 'POST' :
                return this.post(url, data);

            case 'PUT' :
                return this.put(url, data);

            case 'PATCH' :
                return this.patch(url, data);

            case 'DELETE' :
                return this.delete(url, data);

            default :
                console.error('API METHOD ' + api_route.method + ' DOES NOT EXISTS');
                break;
        }
    },
    /* API METHODS */
    get : function(url, data){
        return this.base().get(url);
    },
    getFile : function(url){
        var token = localStorage.getItem('token');
        return axios.create({
            baseURL: config.API_BASE,
            withCredentials: false,
            responseType: 'blob',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization' : token,
                'Autrollization' : token,
                'Hash-Teatro': localStorage.getItem('hash_teatro')
            }
        }).get(url);
    },

    post : function(url, data = { filters: {} }){
        if(!data.filters) data.filters = {};

        return this.base().post(url, data);
    },

    put : function(url, data = { filters: {} }){
        if(!data.filters) data.filters = {};

        return this.base().put(url, data);
    },

    patch : function(url, data = { filters: {} }){
        if(!data.filters) data.filters = {};

        return this.base().patch(url, data);
    },

    delete : function(url, data = { filters: {} }){
        if(!data.filters) data.filters = {};

        return this.base().delete(url, { data: data });
    },

    format_url_params : function(params){
        var source = {};
        var token = localStorage.getItem('token');

        if(params && typeof(params) === 'object'){
            source = params;
        }

        if(token){
            source = {
                ...source,
                api_key: token
            };
        }

        var keys = Object.keys(source).sort();
        var parts = [];

        for(var x = 0; x < keys.length; x++){
            var key = keys[x];
            var value = source[key];

            if(value === null || value === undefined){
                continue;
            }

            if(Array.isArray(value)){
                for(var y = 0; y < value.length; y++){
                    var arrayValue = value[y];
                    var normalizedArrayValue = (arrayValue && typeof(arrayValue) === 'object') ? arrayValue.id : arrayValue;

                    if(normalizedArrayValue === null || normalizedArrayValue === undefined){
                        continue;
                    }

                    parts.push(encodeURIComponent(key) + '[]=' + encodeURIComponent(normalizedArrayValue));
                }
                continue;
            }

            if(typeof(value) === 'object'){
                var ids = [];
                var objectKeys = Object.keys(value).sort();

                for(var j = 0; j < objectKeys.length; j++){
                    var objectValue = value[objectKeys[j]];
                    if(objectValue && objectValue.id !== null && objectValue.id !== undefined){
                        ids.push(objectValue.id);
                    }
                }

                if(ids.length === 0){
                    continue;
                }

                ids.sort(function(a, b){
                    if(a > b) return 1;
                    if(a < b) return -1;
                    return 0;
                });

                parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(ids.join(',')));
                continue;
            }

            parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }

        if(parts.length === 0){
            return '';
        }

        return '?' + parts.join('&');
    },

    format_url_merge_tags : function(url, data){
        for(var i in data) {
            url = url.replace('%' + i + '%', data[i]);
        }
        return url;
    }
}
